import React from 'react';
import { Repeat } from 'lucide-react';

/**
 * Компонент секции рефинансирования
 */
const RefinancingSection = ({ formData, handleInputChange, errors }) => {
  return (
    <fieldset className="mb-8 border-b border-gray-200 dark:border-gray-700 pb-8">
      <div className="flex items-center justify-between mb-5 flex-wrap gap-2">
        <legend className="text-xl font-medium text-gray-800 dark:text-gray-200 flex items-center gap-2">
          <Repeat className="w-5 h-5 text-blue-500"/>
          Рефинансирование
        </legend>
        <div className="flex items-center">
          <label htmlFor="includeRefinancing" className="mr-2 text-sm font-medium text-gray-700 dark:text-gray-300 cursor-pointer select-none">
            Учитывать?
          </label>
          <input
            type="checkbox" id="includeRefinancing" name="includeRefinancing"
            checked={formData.includeRefinancing} onChange={handleInputChange}
            className="form-checkbox"
          />
        </div>
      </div>
      
      {formData.includeRefinancing && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-5 bg-gray-50 dark:bg-gray-800/50 p-4 rounded-md border dark:border-gray-700">
          {/* Месяц рефинансирования */}
          <div>
            <label htmlFor="refinancingMonth" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">
              Месяц рефинансирования
            </label>
            <input
              type="text" id="refinancingMonth" name="refinancingMonth" inputMode="numeric"
              value={formData.refinancingMonth} onChange={handleInputChange}
              className={`form-input ${errors.refinancingMonth ? 'input-error' : ''}`}
              placeholder="60" required={formData.includeRefinancing}
              aria-invalid={!!errors.refinancingMonth} aria-describedby="refinancingMonth-error"
            />
            {errors.refinancingMonth && (
              <p id="refinancingMonth-error" className="mt-1 text-xs text-red-600 dark:text-red-400" role="alert">
                {errors.refinancingMonth}
              </p>
            )}
            <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
              Номер месяца, с которого применяется новая процентная ставка.
            </p>
          </div>
          
          {/* Новая ставка */}
          <div>
            <label htmlFor="refinancingRate" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1.5">
              Новая ставка
            </label>
            <div className="relative rounded-md shadow-sm">
              <input
                type="text" id="refinancingRate" name="refinancingRate" inputMode="decimal"
                value={formData.refinancingRate} onChange={handleInputChange}
                className={`form-input pl-4 pr-10 ${errors.refinancingRate ? 'input-error' : ''}`}
                placeholder="6.0" required={formData.includeRefinancing}
                aria-invalid={!!errors.refinancingRate} aria-describedby="refinancingRate-error"
              />
              <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3">
                <span className="text-gray-500 dark:text-gray-400 sm:text-sm">%</span>
              </div>
            </div>
            {errors.refinancingRate && (
              <p id="refinancingRate-error" className="mt-1 text-xs text-red-600 dark:text-red-400" role="alert">
                {errors.refinancingRate}
              </p>
            )}
            <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
              Рефинансирование выгодно, если новая ставка на 1-2% ниже текущей.
            </p>
          </div>
        </div>
      )}
    </fieldset>
  );
};

export default RefinancingSection;